"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var RiskNoColour = function RiskNoColour(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.2773 5.69959L13.9436 6.43379L13.2773 5.69959C13.2123 5.75857 13.1502 5.82068 13.0912 5.88569C13.0587 5.92337 13.0126 5.9841 12.9976 6.00609C12.9886 6.01997 12.974 6.04349 12.9682 6.05327C12.957 6.07234 12.9488 6.08792 12.9451 6.09479C12.9371 6.10997 12.9307 6.12306 12.9276 6.12947C12.9205 6.14407 12.9131 6.15966 12.9069 6.17305C12.8938 6.20123 12.8765 6.2391 12.8561 6.2842C12.8148 6.37528 12.7563 6.50589 12.6833 6.66972C12.5371 6.99787 12.3308 7.46429 12.0845 8.02496C11.5919 9.14631 10.9381 10.6475 10.2839 12.1777C9.63014 13.7066 8.97351 15.2699 8.47642 16.5134C8.22832 17.1341 8.01652 17.6836 7.86399 18.1129C7.78802 18.3267 7.72313 18.5208 7.6752 18.6841C7.6367 18.8153 7.57899 19.0226 7.56963 19.2158C7.49695 20.7154 8.65373 21.99 10.1534 22.0627C10.241 22.0669 10.3289 22.0669 10.4166 22.0627C10.4162 22.0627 10.4473 22.0625 10.5062 22.0622C10.9283 22.0601 12.7818 22.0506 14.7718 22.0459C17.0357 22.0405 19.3509 22.0418 19.7918 22.0632C21.2914 22.1358 22.566 20.9791 22.6387 19.4794C22.6429 19.3918 22.6429 19.3039 22.6387 19.2162C22.635 19.1666 22.6247 19.0911 22.6197 19.0649C22.6163 19.0487 22.61 19.0218 22.6072 19.0108C22.6016 18.9894 22.5964 18.9725 22.5941 18.9651C22.589 18.9487 22.5843 18.9349 22.582 18.9282C22.5767 18.9128 22.5709 18.8966 22.5658 18.8827C22.5552 18.8535 22.5406 18.8145 22.5232 18.7682C22.4879 18.6746 22.437 18.5409 22.3728 18.3734C22.2441 18.038 22.0602 17.5623 21.8379 16.9917C21.3933 15.8504 20.794 14.3265 20.1747 12.7818C19.5559 11.2385 18.9148 9.66863 18.387 8.4378C18.1236 7.82348 17.8848 7.28512 17.6891 6.87373C17.5916 6.66883 17.5003 6.48568 17.4187 6.3363C17.3531 6.21634 17.2473 6.02891 17.1174 5.88569C16.1084 4.7739 14.3891 4.69058 13.2773 5.69959Z",
    fill: "white",
    stroke: "black",
    strokeWidth: "2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.4129 11.6328C15.5056 11.7029 15.5463 11.7789 15.5516 11.8615C15.5501 11.871 15.5477 11.8857 15.5458 11.9013C15.5444 11.9123 15.543 11.9254 15.5419 11.9403L15.0002 15.4514L14.4586 11.9403C14.4575 11.9254 14.4561 11.9123 14.4547 11.9013C14.4527 11.8857 14.4504 11.871 14.4489 11.8615C14.4542 11.7789 14.4949 11.7029 14.5876 11.6328C14.6954 11.5514 14.8509 11.5 15.0002 11.5C15.1496 11.5 15.3051 11.5514 15.4129 11.6328ZM15.4666 18.0338C15.4666 18.2958 15.2623 18.5001 15.0002 18.5001C14.7382 18.5001 14.5339 18.2958 14.5339 18.0338C14.5339 17.7717 14.7382 17.5674 15.0002 17.5674C15.2623 17.5674 15.4666 17.7717 15.4666 18.0338Z",
    stroke: "black"
  }));
};

RiskNoColour.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
RiskNoColour.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = RiskNoColour;
exports.default = _default;